import { eCouponRepository } from '~/api/repository/e-coupon';

export const E_COUPON_QUERY_KEY = {
  all: ['e-coupon'] as const,

  detail: (eCouponId: string) => ({
    queryKey: [...E_COUPON_QUERY_KEY.all, 'detail', eCouponId] as const,
    queryFn: () => eCouponRepository.getECouponDetail(eCouponId),
  }),
};
